import classes from './ColorCard.module.scss'
import type { ReactNode } from 'react'

export interface Props {
  children: ReactNode
  borderVariance: 'lightPurple' | 'darkPurple' | 'blue' | 'darkBlue' | 'lightBlue' | 'lightGray' | 'inputFieldBorderGray' | 'orange' | 'violet' | 'green' | 'red'
}

const ColorCard = ({
  children,
  borderVariance
}: Props) =>
  <div className={classes.ColorCard + ' ' + classes[borderVariance]}>
    {children}
  </div>

export default ColorCard
